export default __webpack_public_path__ + "static/media/halls_entree.5784d0bc.webp";